<template>
	<div>
		<div class="d-flex align-center">
			<v-tabs
				v-model="tabs"
				height="65"
				active-class="mid-primary"
				color="white">
				<v-tab :href="`#${employeesTypes.applicants.value}`">
					<v-icon class="me-1"> mdi-account-search </v-icon>
					{{ employeesTypes.applicants.text }}
				</v-tab>
				<v-tab :href="`#${employeesTypes.temporaries.value}`">
					<v-icon class="me-1"> mdi-account-clock </v-icon>
					{{ employeesTypes.temporaries.text }}
				</v-tab>
				<v-tab :href="`#${employeesTypes.currently.value}`">
					<v-icon class="me-1"> mdi-account-clock </v-icon>
					{{ employeesTypes.currently.text }}
				</v-tab>
				<v-tab :href="`#${employeesTypes.former.value}`">
					<v-icon class="me-1"> mdi-account-cancel </v-icon>
					{{ employeesTypes.former.text }}
				</v-tab>
				<v-tab :href="`#${employeesTypes.all.value}`">
					<v-icon class="me-1"> mdi-account-group </v-icon>
					{{ employeesTypes.all.text }}
				</v-tab>
			</v-tabs>

			<v-divider
				vertical
				class="me-1 ms-auto"></v-divider>
			<div
				style="width: 300px"
				class="text-center primary--text px-3">
				{{ $T(`routes.${this.$route.meta.i18nTranslateKey}`) }}
			</div>
		</div>

		<v-divider></v-divider>

		<div class="pa-2">
			<b-search
				ref="bSearch"
				:bones="searchItems"
				v-model="search"
				@search="searchEmployee"
				@clear="getAllEmployee()">

				<template>
					<v-btn-toggle
						v-model.number="sort"
						mandatory
						dense
						class="mb-1"
						color="primary"
						@change="searchToggle()"
                	>
                    <v-btn :disabled="loadingEmployees">الترتيب حسب الرقم</v-btn>
					<v-btn :disabled="loadingEmployees">الترتيب حسب  تاريخ بدء العمل</v-btn>
                    <v-btn :disabled="loadingEmployees">ترتيب حسب  تاريخ الولادة</v-btn>
                </v-btn-toggle>
				</template>
				<template v-slot:end>
					<!-- filter button -->
					<div
						class="d-flex"
						v-if="tabs == employeesTypes.applicants.value">
						<!-- filter -->
						<v-btn
							small
							color="secondary"
							@click="filterDrawer = true">
							<v-icon left>mdi-filter</v-icon>
							{{ $T('default-buttons.filterEmployee') }}
							<v-avatar
								v-if="activeFilters.length"
								class="ms-1"
								color="error"
								size="1.3rem">
								<span class="white--text font-weight-bold">{{ activeFilters.length }}</span>
							</v-avatar>
						</v-btn>
						<!-- clear -->
						<v-btn
							v-if="activeFilters.length"
							rounded
							@click="
								cancelFilter();
								getAllEmployee();
							"
							style="min-width: 30px"
							class="px-0"
							small
							dark
							color="alert">
							<v-icon small> $clear </v-icon>
						</v-btn>
					</div>
					<!-- add employee -->
					<v-btn
						class="ms-2"
						v-if="tabs !== employeesTypes.former"
						small
						color="primary"
						:to="{ name: 'employee-info', query: { first: true } }">
						<v-icon left> $add </v-icon>
						{{ $T('add') }}
					</v-btn>
				</template>
			</b-search>

			<!-- search -->
			<customizable-table
				v-if="employeeTableState === employeeTableStateEnum.search"
				:headers="tableHeaders"
				:localStorageName="headersName">
				<template v-slot:default="{ headers, openCustomizer }">
					<bee-handy-table
						ref="employeeTableSearch"
						key="employeeTableSearch"
						:headers="headers"
						:data-table-props="{ disableSort: true }"
						:options-scroll.sync="optionsScroll"
						v-bind="tableBind"
						@pagination-on-scroll:reach-last-row="fetchFilteredEmployees"
						@dblclick:row="routeToEmployee">
						<template v-slot:item.duration="{ item }">
							{{ moment().diff(moment(item.startDate), 'd') }}
						</template>
						<template v-slot:item.name="{ item, header, getShownValueInCell }">
							<div class="d-flex align-center">
								<!-- <v-img
							src="@/assets/Untitled.jpg"
							max-height="2rem"
							max-width="2rem"
							class="ml-2"></v-img> -->
								{{ getShownValueInCell({ item, header }) }}
							</div>
						</template>

						<template v-slot:item.actions="{ item }">
							<tooltip :text="$T('tooltips.preview')">
								<v-btn
									small
									icon
									:to="{
										name: 'personal-info',
										query: { employeeId: item.employeeId },
									}">
									<v-icon
										size="20"
										color="preview">
										$viewEmployee
									</v-icon>
								</v-btn>
							</tooltip>
						</template>
						<template v-slot:top="{}">
							<v-btn
								style="z-index: 3"
								class="me-n2"
								left
								absolute
								@click="openCustomizer"
								x-small
								depressed>
								تعديل
							</v-btn>
						</template>
					</bee-handy-table>
				</template></customizable-table
			>
			<!-- all -->
			<customizable-table
				v-else-if="employeeTableState === employeeTableStateEnum.all"
				:headers="tableHeaders"
				:localStorageName="headersName">
				<template v-slot:default="{ headers, openCustomizer }">
					<bee-handy-table
						ref="employeeTable"
						key="employeeTable"
						:headers="headers"
						:data-table-props="{ disableSort: true }"
						:options-scroll.sync="optionsScroll"
						v-bind="tableBind"
						@pagination-on-scroll:reach-last-row="fetchAllEmployee"
						@dblclick:row="routeToEmployee">
						<template v-slot:item.duration="{ item }">
							{{ moment().diff(moment(item.startDate), 'd') }}
						</template>
						<template v-slot:item.name="{ item, header, getShownValueInCell }">
							<div class="d-flex align-center">
								<!-- <v-img
							src="@/assets/Untitled.jpg"
							max-height="2rem"
							max-width="2rem"
							class="ml-2"></v-img> -->
								{{ getShownValueInCell({ item, header }) }}
							</div>
						</template>

						<template v-slot:item.actions="{ item }">
							<tooltip :text="$T('tooltips.preview')">
								<v-btn
									small
									icon
									:to="{
										name: 'personal-info',
										query: { employeeId: item.employeeId },
									}">
									<v-icon
										size="20"
										color="preview">
										$viewEmployee
									</v-icon>
								</v-btn>
							</tooltip>
						</template>
						<template v-slot:top="{}">
							<v-btn
								style="z-index: 3"
								class="me-n2"
								left
								absolute
								@click="openCustomizer"
								x-small
								depressed>
								تعديل
							</v-btn>
						</template>
					</bee-handy-table>
				</template></customizable-table
			>
			<!-- filter -->
			<bee-handy-table
				ref="employeeTableFilter"
				key="employeeTableFilter"
				v-else-if="employeeTableState === employeeTableStateEnum.filter"
				:headers="filterHeaders"
				:data-table-props="{
					expanded: filterEmployeeExpand,
					showExpand: true,
					disableSort: true,
				}"
				:options-scroll.sync="optionsScroll"
				v-bind="tableBind"
				@pagination-on-scroll:reach-last-row="fetchFilteredEmployees"
				@dblclick:row="routeToEmployee">
				<template v-slot:item.name="{ value }">
					<div class="d-flex align-center">
						<!-- <v-img
							src="@/assets/Untitled.jpg"
							max-height="2rem"
							max-width="2rem"
							class="ml-2"></v-img> -->

						{{ value }}
					</div>
				</template>

				<!-- chips -->
				<template v-slot:item.job="{ value }">
					<v-chip-group column>
						<v-chip
							small
							v-for="(tag, j) in value"
							:key="j">
							{{ positions?.find((e) => e.id === tag).name }}
						</v-chip>
					</v-chip-group>
				</template>
				<template v-slot:item.prevJob="{ value }">
					<v-chip-group column>
						<v-chip
							small
							v-for="(tag, j) in value"
							:key="j">
							<!-- todo change to jobName -->
							{{ tag.jobName }} - {{ tag.companyName }}
						</v-chip>
					</v-chip-group>
				</template>
				<template v-slot:item.academicDegrees="{ value }">
					<v-chip-group column>
						<v-chip
							small
							v-for="(tag, j) in value"
							:key="j">
							{{ getEnumByValue(tag.certificate, degrees) }}
						</v-chip>
					</v-chip-group>
				</template>
				<template v-slot:item.academicSpecifications="{ value }">
					<v-chip-group column>
						<v-chip
							small
							v-for="(tag, j) in value"
							:key="j">
							{{ tag.specialization }}
						</v-chip>
					</v-chip-group>
				</template>

				<!-- rating -->
				<template v-slot:item.language="{ value }">
					<div class="py-1">
						<div
							v-for="(lang, i) in value"
							:key="i">
							<div class="d-flex align-center">
								<div
									class="text-caption"
									style="width: 50px">
									{{ lang.languageName }}
								</div>
								<v-rating
									readonly
									dense
									length="5"
									size="20"
									:value="lang.level">
								</v-rating>
							</div>
						</div>
					</div>
				</template>
				<template v-slot:item.computer="{ value }">
					<div class="py-1">
						<div
							v-for="(item, i) in value"
							:key="i">
							<div class="d-flex align-center">
								<div
									class="text-caption"
									style="width: 90px; line-height: 1em">
									{{ item.computerSkillName }}
								</div>
								<v-rating
									readonly
									dense
									length="5"
									size="20"
									:value="item.value">
								</v-rating>
							</div>
						</div>
					</div>
				</template>
				<template v-slot:item.expertise="{ value }">
					<div class="py-1">
						<div
							v-for="(item, i) in value"
							:key="i">
							<div class="d-flex align-center">
								<div
									class="text-caption"
									style="width: 90px; line-height: 1em">
									{{ item.skillName }}
								</div>
								<v-rating
									readonly
									dense
									length="5"
									size="20"
									:value="item.value">
								</v-rating>
							</div>
						</div>
					</div>
				</template>

				<template v-slot:item.actions="{ item }">
					<tooltip :text="$T('tooltips.preview')">
						<v-btn
							small
							icon
							:to="{ name: 'personal-info', query: { employeeId: item.employeeId } }">
							<v-icon
								size="20"
								color="preview">
								$viewEmployee
							</v-icon>
						</v-btn>
					</tooltip>
				</template>

				<template v-slot:expanded-item="{ headers, item }">
					<td
						:colspan="headers.length"
						class="pa-2">
						<div v-if="item.phone">
							{{ $T('contact.phone') }}:
							<span
								class="font-weight-bold"
								dir="ltr">
								{{ item.phone }}
							</span>
						</div>
						<div v-if="item.email">
							{{ $T('contact.email') }}:
							<a
								:href="'mailto://' + item.email"
								target="_blank"
								class="font-weight-bold">
								{{ item.email }}
							</a>
						</div>
						<div>
							تاريخ تقديم الاستمارة:
							<span class="font-weight-bold"> {{ moment(item.formDate).format('L') }} </span>
						</div>
					</td>
				</template>
			</bee-handy-table>
		</div>

		<v-navigation-drawer
			v-model="filterDrawer"
			:permanent="filterDrawer"
			:width="openDrawerFromQuery ? '100vw' : '400'"
			absolute
			temporary>
			<v-btn
				@click="filterDrawer = false"
				icon
				absolute
				top
				left
				class="mt-n3 me-n3"
				style="z-index: 1">
				<v-icon> $clear </v-icon>
			</v-btn>
			<v-list
				class="mx-auto"
				dense
				max-width="800">
				<!-- sex -->
				<v-list-item>
					<v-list-item-content>
						<v-radio-group
							v-model="filter.sex"
							mandatory
							row
							dense
							hide-details
							class="mt-0"
							:label="$T('filters.sex')">
							<v-radio
								:label="$T('filters.NO')"
								:value="null"></v-radio>
							<v-radio
								:label="$T('male')"
								:value="sex.male"></v-radio>
							<v-radio
								:label="$T('female')"
								:value="sex.female"></v-radio>
						</v-radio-group>
					</v-list-item-content>
				</v-list-item>
				<!-- job -->
				<v-list-item>
					<v-list-item-content>
						<b-async-input :storeName="'filters/fetchJobDescriptions'">
							<template v-slot:default="{ items, loading, focus }">
								<v-autocomplete
									v-model="filter.job"
									:items="items"
									:loading="loading"
									item-text="name"
									item-value="id"
									multiple
									small-chips
									deletable-chips
									dense
									outlined
									hide-details
									return-object
									:label="$T('filters.jobs')"
									@focus="focus">
								</v-autocomplete> </template
						></b-async-input>
					</v-list-item-content>
				</v-list-item>
				<!-- prev job -->
				<v-list-item>
					<v-list-item-content>
						<b-async-input :storeName="'filters/fetchOldJobsFilters'">
							<template v-slot:default="{ items, loading, focus }">
								<v-autocomplete
									v-model="filter.prevJob"
									:items="items"
									:loading="loading"
									item-text="jobName"
									item-value="id"
									multiple
									small-chips
									deletable-chips
									dense
									outlined
									hide-details
									return-object
									:label="$T('filters.prevJobs')"
									@focus="focus">
								</v-autocomplete> </template
						></b-async-input>
					</v-list-item-content>
				</v-list-item>
				<!-- academic -->
				<v-list-item>
					<v-expansion-panels flat>
						<v-expansion-panel>
							<v-divider></v-divider>
							<v-expansion-panel-header class="pa-1">
								{{ $T('filters.academic') }}
							</v-expansion-panel-header>
							<v-expansion-panel-content>
								<v-autocomplete
									v-model="filter.academicDegrees"
									:items="Object.values(degrees)"
									class="mb-3"
									multiple
									small-chips
									deletable-chips
									dense
									outlined
									hide-details
									:label="$T('filters.academicDegrees')">
								</v-autocomplete>
								<b-async-input :storeName="'filters/fetchSpecificationFilters'">
									<template v-slot:default="{ items, loading, focus }">
										<v-autocomplete
											v-model="filter.academicSpecifications"
											:items="items"
											:loading="loading"
											item-text="specialization"
											item-value="id"
											class="mb-3"
											multiple
											small-chips
											deletable-chips
											dense
											outlined
											hide-details
											:label="$T('filters.academicSpecifications')"
											@focus="focus">
										</v-autocomplete>
									</template>
								</b-async-input>
								<v-checkbox
									dense
									hide-details
									:label="$T('filters.academicFinish')"
									v-model="filter.academicFinish"></v-checkbox>
							</v-expansion-panel-content>
							<v-divider></v-divider>
						</v-expansion-panel>
					</v-expansion-panels>
				</v-list-item>
				<!-- language -->
				<v-list-item>
					<v-list-item-content>
						<b-async-input :storeName="'filters/fetchLanguageFilters'">
							<template v-slot:default="{ items, loading, focus }">
								<b-rating
									v-model="filter.language"
									:items="items"
									:loading="loading"
									@focus="focus"
									:label="$T('filters.language')"></b-rating>
							</template>
						</b-async-input>
					</v-list-item-content>
				</v-list-item>
				<!-- computer -->
				<v-list-item>
					<v-list-item-content>
						<b-async-input :storeName="'filters/fetchComputerFilters'">
							<template v-slot:default="{ items, loading, focus }">
								<b-rating
									v-model="filter.computer"
									:items="items"
									:loading="loading"
									@focus="focus"
									:label="$T('filters.computer')"></b-rating>
							</template>
						</b-async-input>
					</v-list-item-content>
				</v-list-item>
				<!-- expertise -->
				<v-list-item>
					<v-list-item-content>
						<b-async-input :storeName="'filters/fetchExpertiseFilters'">
							<template v-slot:default="{ items, loading, focus }">
								<b-rating
									v-model="filter.expertise"
									:items="items"
									:loading="loading"
									@focus="focus"
									:label="$T('filters.expertise')"></b-rating>
							</template>
						</b-async-input>
					</v-list-item-content>
				</v-list-item>
				<!-- military -->
				<v-list-item>
					<v-list-item-content>
						<v-autocomplete
							v-model="filter.military"
							:items="Object.values(militaryState).filter((e) => e.value)"
							multiple
							small-chips
							deletable-chips
							dense
							outlined
							hide-details
							:label="$T('filters.military')">
						</v-autocomplete>
					</v-list-item-content>
				</v-list-item>
				<!-- salary -->
				<v-list-item>
					<v-list-item-content>
						<div class="d-flex">
							<span>{{ $T('filters.salary') }}</span>
							<v-text-field
								class="mx-2"
								v-model="filter.minSalary"
								:label="$T('from')"
								dense
								outlined
								hide-details></v-text-field>
							<v-text-field
								v-model="filter.maxSalary"
								:label="$T('to')"
								dense
								outlined
								hide-details></v-text-field>
						</div>
					</v-list-item-content>
				</v-list-item>
				<!-- age -->
				<v-list-item>
					<v-list-item-content>
						<div class="d-flex">
							<span>{{ $T('filters.age') }}</span>
							<v-text-field
								class="mx-2"
								v-model="filter.minAge"
								:label="$T('from')"
								dense
								outlined
								hide-details></v-text-field>
							<v-text-field
								v-model="filter.maxAge"
								:label="$T('to')"
								dense
								outlined
								hide-details></v-text-field>
						</div>
					</v-list-item-content>
				</v-list-item>
				<!-- others -->
				<v-list-item>
					<v-list-item-content>
						<v-list-item-content>
							<v-radio-group
								v-model="filter.nightWork"
								class="mt-0"
								mandatory
								row
								dense
								hide-details
								:label="$T('filters.nightWork')">
								<v-radio
									:label="$T('filters.NO')"
									:value="null"></v-radio>
								<v-radio
									:label="$T('yes')"
									:value="true"></v-radio>
								<v-radio
									:label="$T('no')"
									:value="false"></v-radio>
							</v-radio-group>
						</v-list-item-content>
						<v-list-item-content>
							<v-radio-group
								v-model="filter.extraTime"
								class="mt-0"
								mandatory
								row
								dense
								hide-details
								:label="$T('filters.extraTime')">
								<v-radio
									:label="$T('filters.NO')"
									:value="null"></v-radio>
								<v-radio
									:label="$T('yes')"
									:value="true"></v-radio>
								<v-radio
									:label="$T('no')"
									:value="false"></v-radio>
							</v-radio-group>
						</v-list-item-content>
						<v-list-item-content>
							<v-radio-group
								v-model="filter.relative"
								class="mt-0"
								mandatory
								row
								dense
								hide-details
								:label="$T('filters.relative')">
								<v-radio
									:label="$T('filters.NO')"
									:value="null"></v-radio>
								<v-radio
									:label="$T('yes')"
									:value="true"></v-radio>
								<v-radio
									:label="$T('no')"
									:value="false"></v-radio>
							</v-radio-group>
						</v-list-item-content>
					</v-list-item-content>
				</v-list-item>
				<!-- button -->
				<v-list-item>
					<v-list-item-content>
						<v-btn
							class="flex-grow-1"
							@click="filterEmployee"
							color="primary">
							{{ $T('default-buttons.search') }}
						</v-btn>
						<v-scroll-x-reverse-transition
							hide-on-leave
							leave-absolute>
							<v-btn
								v-if="activeFilters.length"
								@click="clearFilters"
								:disabled="Boolean(activeFilters.length || loadingEmployees)"
								:loading="loadingEmployees"
								outlined
								color="error"
								class="ms-3 d-block">
								{{ $T('default-buttons.delete') }}
							</v-btn>
						</v-scroll-x-reverse-transition>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-navigation-drawer>
	</div>
</template>

<script>
import moment, { DATE_FORMAT } from '@/utils/moment';
import BRating from '@/components/BRating.vue';

import { sex, degrees, militaryState, contactsType, employeesTypes } from '@/utils/enum';
import { getEnumByValue } from '@/utils/helpers';
import { mapState } from 'vuex';

const employeeTableStateEnum = {
	all: 1,
	search: 2,
	filter: 3,
};

export default {
	name: 'Employees',

	components: {
		BRating,
	},

	data() {
		return {
			tabs: String(employeesTypes.currently.value),
			filterDrawer: null,
			openDrawerFromQuery: false,
			employeeTableState: employeeTableStateEnum.all,
			employeeItemsCount: 0,

			loadingEmployees: false,

			searchItems: [
				{
					type: 'name',
					value: 'name',
				},
				{
					type: 'section',
					value: 'section',
				},
				{
					type: 'position',
					value: 'position',
				},
			],
			search: {},

			allHeaders: [
				{
					text: this.$T('headers.code'),
					name: 'code',
					value: 'code',
					width: 0,
					class: 'pe-0 ps-1',
					cellClass: 'pe-0 ps-1',
				},
				{ text: this.$T('headers.employee-name'), name: 'name', value: 'name' },
				{ text: this.$T('headers.employees.mobile'), name: 'phone', value: 'phone', sortable: false },
				{ text: this.$T('headers.employees.email'), name: 'email', value: 'email', sortable: false },
				{
					text: this.$T('headers.employees.formDate'),
					name: 'formDate',
					value: 'formDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.startDate'),
					name: 'startDate',
					value: 'startDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.duration'),
					name: 'duration',
					value: 'duration',
					sortable: false,
				},
			],
			applicantsHeaders: [
				{
					text: this.$T('headers.code'),
					name: 'code',
					value: 'code',
					width: 0,
					class: 'pe-0 ps-1',
					cellClass: 'pe-0 ps-1',
				},
				{ text: this.$T('headers.employee-name'), name: 'name', value: 'name' },
				{ text: this.$T('headers.employees.mobile'), name: 'phone', value: 'phone', sortable: false },
				{ text: this.$T('headers.employees.email'), name: 'email', value: 'email', sortable: false },
				{
					text: this.$T('headers.employees.formDate'),
					name: 'formDate',
					value: 'formDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.startDate'),
					name: 'startDate',
					value: 'startDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.duration'),
					name: 'duration',
					value: 'duration',
					sortable: false,
				},
			],
			temporariesHeaders: [
				{
					text: this.$T('headers.code'),
					name: 'code',
					value: 'code',
					width: 0,
					class: 'pe-0 ps-1',
					cellClass: 'pe-0 ps-1',
				},
				{ text: this.$T('headers.employee-name'), name: 'name', value: 'name' },
				{ 
					text: 'القسم', 
					name: 'section', 
					value: 'section', 
					setValueExpr: (v) => {
						if (!this.sections || !this.sections.length) return null;

						return this.sections.find((e) => e.id === v)?.name;
					}, 
					sortable: false 
				},
				{
					text: 'المسمى',
					name: 'role',
					value: 'role',
					setValueExpr: (v) => {
						if (!this.positions || !this.positions.length) return null;

						return this.positions.find((e) => e.id === v)?.name;
					},
					sortable: false,
				},
				{ text: this.$T('headers.employees.mobile'), name: 'phone', value: 'phone', sortable: false },
				{ text: this.$T('headers.employees.email'), name: 'email', value: 'email', sortable: false },
				{
					text: this.$T('headers.employees.formDate'),
					name: 'formDate',
					value: 'formDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.startDate'),
					name: 'startDate',
					value: 'startDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.duration'),
					name: 'duration',
					value: 'duration',
					sortable: false,
				},
			],
			currentlyHeaders: [
				{
					text: this.$T('headers.code'),
					name: 'code',
					value: 'code',
					width: 0,
					class: 'pe-0 ps-1',
					cellClass: 'pe-0 ps-1',
				},
				{ text: this.$T('headers.employee-name'), name: 'name', value: 'name' },
				{ 
					text: 'القسم', 
					name: 'section', 
					value: 'section',
					setValueExpr: (v) => {
						if (!this.sections || !this.sections.length) return null;

						return this.sections.find((e) => e.id === v)?.name;
					},
				},
				{
					text: 'المسمى',
					name: 'role',
					value: 'role',
					setValueExpr: (v) => {
						if (!this.positions || !this.positions.length) return null;

						return this.positions.find((e) => e.id === v)?.name;
					},
					sortable: false,
				},
				{ text: this.$T('headers.employees.mobile'), name: 'phone', value: 'phone', sortable: false },
				{ text: this.$T('headers.employees.email'), name: 'email', value: 'email', sortable: false },
				{
					text: this.$T('headers.employees.formDate'),
					name: 'formDate',
					value: 'formDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.startDate'),
					name: 'startDate',
					value: 'startDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.duration'),
					name: 'duration',
					value: 'duration',
					sortable: false,
				},
			],
			formerHeaders: [
				{
					text: this.$T('headers.code'),
					name: 'code',
					value: 'code',
					width: 0,
					class: 'pe-0 ps-1',
					cellClass: 'pe-0 ps-1',
				},
				{ text: this.$T('headers.employee-name'), name: 'name', value: 'name' },
				{ text: this.$T('headers.employees.mobile'), name: 'phone', value: 'phone', sortable: false },
				{ text: this.$T('headers.employees.email'), name: 'email', value: 'email', sortable: false },
				{
					text: this.$T('headers.employees.formDate'),
					name: 'formDate',
					value: 'formDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.startDate'),
					name: 'startDate',
					value: 'startDate',
					type: 'date',
					dateFormat: DATE_FORMAT,
					sortable: false,
				},
				{
					text: this.$T('headers.employees.duration'),
					name: 'duration',
					value: 'duration',
					sortable: false,
				},
			],

			// filters
			filter: {
				sex: null,
				job: null,
				prevJob: null,
				academicDegrees: null,
				academicSpecifications: null,
				academicFinish: null,
				language: null,
				computer: null,
				expertise: null,
				military: null,
				minSalary: null,
				maxSalary: null,
				minAge: null,
				maxAge: null,
				nightWork: null,
				extraTime: null,
				relative: null,
			},
			filterHeaders: [],
			activeFilters: [],

			filterEmployeeExpand: [],
			optionsScroll: null,

			sex,
			degrees,
			contactsType,
			employeeTableStateEnum,
			militaryState,
			employeesTypes,
			sort: 0
		};
	},

	watch: {
		tabs() {
			this.getAllEmployee();
		},
		$route() {
			// close and open the filter drawer
			if (this.$route.query.search) {
				this.filterDrawer = true;
				this.tabs = employeesTypes.applicants.value;
			} else {
				this.filterDrawer = false;
				this.openDrawerFromQuery = false;
			}
		},
	},

	computed: {
		tableBind() {
			return {
				items: [],
				class: 'with-sex',
				dense: true,
				zebra: true,
				'fixed-header': true,
				'hide-default-footer': true,
				height: this.$vuetify.breakpoint.height - 160,
				'row-highlight-expression': (e) => e.sex === sex.female,
				'row-highlight-expression-class': 'female-row',

				'pagination-on-scroll': true,
				'pagination-on-scroll-server-items': true,
				'pagination-on-scroll-loading': this.loadingEmployees,
				'server-items-length': Number(this.employeeItemsCount),
				'items-per-page': 30,
			};
		},
		tableHeaders() {
			switch (Number(this.tabs)) {
				case this.employeesTypes.all.value:
					return this.allHeaders;
				case this.employeesTypes.applicants.value:
					return this.applicantsHeaders;
				case this.employeesTypes.temporaries.value:
					return this.temporariesHeaders;
				case this.employeesTypes.currently.value:
					return this.currentlyHeaders;
				case this.employeesTypes.former.value:
					return this.formerHeaders;
				default:
					return this.allHeaders;
			}
		},
		headersName() {
			switch (Number(this.tabs)) {
				case this.employeesTypes.all.value:
					return 'employees.all';
				case this.employeesTypes.applicants.value:
					return 'employees.applicants';
				case this.employeesTypes.temporaries.value:
					return 'employees.temporaries';
				case this.employeesTypes.currently.value:
					return 'employees.currently';
				case this.employeesTypes.former.value:
					return 'employees.former';
				default:
					return 'employees.all';
			}
		},
		...mapState({
			sections: (state) => state.section.sections,
			positions: (state) => state.positions.positions,
		}),
	},

	methods: {
		searchToggle () {
			if(this.employeeTableState === employeeTableStateEnum.search) {
				this.$refs.employeeTableSearch.resetShownRows()
			} else if(this.employeeTableState === employeeTableStateEnum.all) {
				this.$refs.employeeTable.resetShownRows()
			} else if(this.employeeTableState === employeeTableStateEnum.filter) {
				this.$refs.employeeTableFilter.resetShownRows()
			}
			this.getAllEmployee()
		},
		routeToEmployee(_, { item }) {
			this.$router.push({ name: 'personal-info', query: { employeeId: item.employeeId } }, () => {});
		},

		fetchFilteredEmployees({ page, itemsPerPage }) {
			const obj =
				this.employeeTableState === employeeTableStateEnum.search
					? {
							name: this.search.name,
							section: this.search.section ? [this.search.section] : null,
							position: this.search.position
					  }
					: this.filter;
			this.loadingEmployees = true;
			this.$store
				.dispatch('employee/fetchFilteredEmployees', {
					Page: page,
					PerPage: itemsPerPage,
					Status: this.tabs,
					OrderByBirthDate: +this.sort === 2, 
					OrderByNum: this.sort === 0,
					OrderByStartDate: this.sort === 1,
					...obj,
				})
				.then((res) => {
					this.employeeItemsCount = res.count;
					this.employeeTableState === employeeTableStateEnum.search
						? this.$refs.employeeTableSearch.addScrollItems(res.data)
						: this.$refs.employeeTableFilter.addScrollItems(res.data);
				})
				.catch((err) => {
					err.default && err.default();
				})
				.finally(() => {
					this.loadingEmployees = false;
				});
		},
		fetchAllEmployee({ page, itemsPerPage }) {
			this.loadingEmployees = true;
			this.$store
				.dispatch('employee/fetchAllEmployee', {
					Page: page,
					PerPage: itemsPerPage,
					Status: this.tabs,
					OrderByBirthDate: +this.sort === 2, 
					OrderByNum: this.sort === 0,
					OrderByStartDate: this.sort === 1
				})
				.then((res) => {
					console.log(res.data[0])
					this.employeeItemsCount = res.count;
					this.$refs.employeeTable.addScrollItems(res.data);
				})
				.catch((err) => {
					err.default && err.default();
				})
				.finally(() => {
					this.loadingEmployees = false;
				});
		},

		changeFilterHeaders() {
			const x = [
				{
					text: this.$T('headers.code'),
					name: 'code',
					value: 'code',
					width: 0,
					class: 'pe-0 ps-1',
					cellClass: 'pe-0 ps-1',
				},
				{ text: this.$T('headers.employee-name'), name: 'name', value: 'name' },
			];

			if (this.filter.job && this.filter.job.length)
				x.push({ text: this.$T('headers.jobs'), name: 'job', value: 'job' });

			if (this.filter.prevJob && this.filter.prevJob.length)
				x.push({ text: this.$T('headers.prevJob'), name: 'prevJob', value: 'prevJob' });

			if (this.filter.academicDegrees && this.filter.academicDegrees.length)
				x.push({
					text: this.$T('headers.academicDegrees'),
					name: 'academicDegrees',
					value: 'academicDegrees',
				});

			if (this.filter.academicSpecifications && this.filter.academicSpecifications.length)
				x.push({
					text: this.$T('headers.academicSpecifications'),
					name: 'academicSpecifications',
					value: 'academicSpecifications',
				});

			if (this.filter.language && this.filter.language.length)
				x.push({ text: this.$T('headers.language'), name: 'language', value: 'language' });

			if (this.filter.computer && this.filter.computer.length)
				x.push({ text: this.$T('headers.computer'), name: 'computer', value: 'computer' });

			if (this.filter.expertise && this.filter.expertise.length)
				x.push({ text: this.$T('headers.expertise'), name: 'expertise', value: 'expertise' });

			if (this.filter.minSalary || this.filter.maxSalary)
				x.push({ text: this.$T('headers.salary'), name: 'salary', value: 'salary' });

			if (this.filter.minAge || this.filter.maxAge)
				x.push({ text: this.$T('headers.age'), name: 'age', value: 'age' });

			x.push({
				text: '',
				name: 'actions',
				value: 'actions',
				sortable: false,
				noInput: true,
				width: 30,
			});

			this.filterHeaders = x;

			let arr = Object.keys(this.filter);
			arr = arr.filter((e) => this.filter[e] !== null && this.filter[e].length !== 0);
			this.activeFilters = arr;
		},

		getAllEmployee() {
			this.cancelFilter();
			this.cancelSearch();
			this.employeeTableState = employeeTableStateEnum.all;
			this.$nextTick(() => {
				this.$refs.employeeTable.resetShownRows();
			});
			this.fetchAllEmployee({ page: 1, itemsPerPage: 30 });
		},
		searchEmployee() {
			this.cancelFilter();
			this.employeeTableState = employeeTableStateEnum.search;
			this.$nextTick(() => {
				this.$refs.employeeTableSearch.resetShownRows();
			});
			this.fetchFilteredEmployees({ page: 1, itemsPerPage: 30 });
		},
		filterEmployee() {
			this.cancelSearch();
			this.employeeTableState = employeeTableStateEnum.filter;
			this.$nextTick(() => {
				this.$refs.employeeTableFilter.resetShownRows();
			});
			this.fetchFilteredEmployees({ page: 1, itemsPerPage: 30 });

			this.changeFilterHeaders();
			this.filterDrawer = false;
			this.openDrawerFromQuery = false;
		},

		cancelSearch() {
			this.$refs.bSearch.justClear();
		},
		cancelFilter(x) {
			this.clearFilters();
			this.activeFilters = [];
		},
		clearFilters() {
			for (const key in this.filter) {
				if (Object.hasOwnProperty.call(this.filter, key)) {
					this.filter[key] = null;
				}
			}
		},
		moment,
		getEnumByValue,
	},

	mounted() {
		if (this.$route.query.search) {
			this.filterDrawer = true;
			this.openDrawerFromQuery = true;
		}
		this.getAllEmployee();
	},
};
</script>
